import styled from 'styled-components'

export default styled.h2`
  color: ${({ theme }) => theme.colors.headers};
  font-size: 2.2em;
  font-weight: 500;
`
